// cache-buster: บังคับโหลดใหม่เฉพาะรูปที่ upload โดย user
// (member, cover, business, product, packaging, carry, trust, certificate)
// ไม่แตะรูป static เช่น icon, asset, step-*.png เพื่อไม่กระทบ performance
document.addEventListener('DOMContentLoaded', () => {
  const DYNAMIC_PATHS = /\/(member|cover|business|product|packaging|carry|trust|certificate)\//;
  const ts = new Date().getTime();

  document.querySelectorAll('img').forEach(img => {
    const src = img.getAttribute('src');
    if (src && DYNAMIC_PATHS.test(src)) {
      img.src = src.split('?')[0] + '?v=' + ts;
    }
  });
});
